import type { CategoriesService } from '~/shared/api/ke-gateway/categories';
import { CatalogManager } from './CatalogManager';
import { DataManager } from './DataManager';
import type { IPopup } from '@mm-frontend/mm-web-ui-kit';

export class CategoriesController {
  private catalogManager: CatalogManager;
  private dataManager: DataManager;

  constructor(client: CategoriesService) {
    this.catalogManager = new CatalogManager();
    this.dataManager = new DataManager(client);
  }

  // DataManager
  public async fetchCategories(): Promise<void> {
    await this.dataManager.fetchCategories();
  }

  public get isCategoriesLoaded() {
    return this.dataManager.isCategoriesLoaded;
  }

  public get rootCategories() {
    return this.dataManager.rootCategories;
  }

  public get promoCategories() {
    return this.dataManager.promoCategories;
  }

  public get isLoading() {
    return this.dataManager.isLoading;
  }

  public get isCatalogModalOpened() {
    return this.catalogManager.isModalOpened;
  }

  // CatalogManager
  public setCatalogPopup(popup: IPopup) {
    this.catalogManager.setPopup(popup);
  }

  public openCatalogModal() {
    this.catalogManager.openModal();
  }

  public closeCatalogModal() {
    this.catalogManager.closeModal();
  }

  public _getTrackerPayload() {
    return this.dataManager._trackerPayload;
  }
}
